import Media, { MediaProvider, MediaProviderName } from '~/models/Media'
import { ApiMedia, ApiSource } from '~/passporter-services/media/apitype'

export class MediaEntityMapper {
	static toMedia = (media: ApiMedia): Media => {
		return new Media({
			created_at: media.created,
			id: media.id,
			metadata: media.metadata,
			name: media.name,
			ownerId: media.owner_id,
			size: media.size,
			state: media.state,
			type: media.type,
			url: media.url,
			pending: media.pending,
			provider: this.toProvider(media.provider, media.source),
		})
	}

	static toMedias = (apiMedias: ApiMedia[]): Media[] => {
		const mappedMedias = apiMedias.map((apiMedia: ApiMedia) => this.toMedia(apiMedia))
		return mappedMedias.filter((media: Media) => media.state === 'ready')
	}

	static toAllMedias = (apiMedias: ApiMedia[]): Media[] => {
		return apiMedias.map((apiMedia: ApiMedia) => this.toMedia(apiMedia))
	}

	static toProvider = (provider: string, source?: ApiSource): MediaProvider => {
		const mediaProvider: MediaProvider = {
			name: provider as MediaProviderName,
			authorName: source?.author_name,
			authorProfileUrl: source?.attribution_url,
			authorPicture: source?.author_picture,
		}
		return mediaProvider
	}
}
